module.exports = __webpack_public_path__ + "static/media/AppIntroVideo.9eb897bb.MP4";